import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Contact = () => {
  const navigate = useNavigate();
  const [formContact, setFormContact] = useState({
    fullName: ``,
    email: ``,
    phone: ``,
    message: ``,
  });

  const handleContact = () => {
    if (!formContact.fullName || formContact.fullName.trim() === ``) {
      toast("Vui lòng nhập họ và tên!", {
        type: "error",
        autoClose: 1000,
      });
      return;
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!formContact.email) {
      toast("Email không được để trống!", {
        type: "error",
        autoClose: 1000,
      });
      return;
    } else if (!emailPattern.test(formContact.email)) {
      toast("Email không hợp lệ!", {
        type: "error",
        autoClose: 1000,
      });
      return;
    }

    const phonePattern = /^[0-9]{10}$/;
    if (!formContact.phone) {
      toast("Số điện thoại không được để trống!", {
        type: "error",
        autoClose: 1000,
      });
      return;
    } else if (!phonePattern.test(formContact.phone)) {
      toast("Số điện thoại không hợp lệ!", {
        type: "error",
        autoClose: 1000,
      });
      return;
    }

    axios
      .post(`/api/v1/contacts`, formContact)
      .then((res) => {
        toast("Liên hệ thành công!", {
          type: "success",
          autoClose: 1000,
        });
        navigate(`/`);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className="login-signup-container mt-4">
        <div className="contact-title">Liên hệ</div>

        <div className="contact-layout">
          <div className="login-signup-label">
            Họ và tên<i className="text-danger">*</i>
          </div>
          <div className="login-signup-box">
            <input
              type="text"
              className="login-signup-input"
              onChange={(e) =>
                setFormContact({ ...formContact, fullName: e.target.value })
              }
            />
          </div>
          <div className="login-signup-label">
            Email<i className="text-danger">*</i>
          </div>
          <div className="login-signup-box">
            <input
              type="text"
              className="login-signup-input"
              onChange={(e) =>
                setFormContact({ ...formContact, email: e.target.value })
              }
            />
          </div>
          <div className="login-signup-label">
            Số điện thoại<i className="text-danger">*</i>
          </div>
          <div className="login-signup-box">
            <input
              type="text"
              className="login-signup-input"
              onChange={(e) =>
                setFormContact({ ...formContact, phone: e.target.value })
              }
            />
          </div>
          <div className="login-signup-label">Nội dung</div>
          <div className="login-signup-box">
            <textarea
              className="order-textarea"
              rows="3"
              cols="50"
              placeholder="Nhập lời nhắn của bạn"
              onChange={(e) =>
                setFormContact({ ...formContact, message: e.target.value })
              }
            />
          </div>
          <div style={{ textAlign: "end" }}>
            <button className="login-signup-button" onClick={handleContact}>
              Gửi liên hệ
            </button>
          </div>
        </div>
        <div className="contact-maps">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4394.399040590237!2d105.77736297999058!3d10.027668209450011!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31a0899731556447%3A0x8cd746e78b5741d2!2zVGhhbmggRmxvd2VyIC0gU2hvcCBIb2EgVMawxqFpIEPhuqduIFRoxqE!5e1!3m2!1svi!2s!4v1737108213141!5m2!1svi!2s"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </>
  );
};

export default Contact;
